// src/api/apiMethods.js
import apiClient from "./apiClient";
import endpoints from "./endpoints";

export const getCreateUser = (data, params, headers) =>
  apiClient.post(endpoints.getCreateUser, data, {
    params,
    headers,
    withCredentials: true,
  });
export const loginOut = (params, headers) =>
  apiClient.get(endpoints.loginOut, {
    params,
    headers,
    withCredentials: true,
  });

export const getUserInfo = (params, headers) =>
  apiClient.get(endpoints.getUserInfo, {
    params,
    headers,
    withCredentials: true,
  });

export const getGameList = (params, headers) =>
  apiClient.get(endpoints.getGameList, {
    params,
    headers,
    withCredentials: true,
  });

export const getCurrencyList = (params, headers) =>
  apiClient.get(endpoints.getCurrencyList, {
    params,
    headers,
    withCredentials: true,
  });

export const getWheelList = (params, headers) =>
  apiClient.get(endpoints.getWheelList, {
    params,
    headers,
    withCredentials: true,
  });
export function postCreateSpin(params) {
  console.log(params);
  const obj = { ...params };
  const urlWithParams = `${endpoints.postCreateSpin}?uid=${params.uid}`;
  return apiClient.post(urlWithParams, JSON.stringify(obj), {
    headers: {
      "Content-Type": "application/json",
    },
    skipLoading: true,
    withCredentials: true,
  });
}

export function postConfirmSpin(params) {
  console.log(params);
  const obj = { ...params };
  const urlWithParams = `${endpoints.postConfirmSpin}?uid=${params.uid}`;
  return apiClient.post(urlWithParams, JSON.stringify(obj), {
    headers: {
      "Content-Type": "application/json",
    },
    skipLoading: true,
    withCredentials: true,
  });
}

export const taskList = (params, headers) =>
  apiClient.get(endpoints.taskList, {
    params,
    headers,
    withCredentials: true,
  });
export const eventTask = (params, headers) =>
  apiClient.get(endpoints.eventTask, {
    params,
    headers,
    withCredentials: true,
  });

export function createTask(params) {
  const obj = { ...params };
  const urlWithParams = `${endpoints.createTask}?uid=${params.uid}`;
  return apiClient.post(urlWithParams, JSON.stringify(obj), {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });
}

export function eventConfirm(params) {
  console.log(params);
  const obj = { ...params };
  const urlWithParams = `${endpoints.eventConfirm}?uid=${params.uid}`;
  return apiClient.post(urlWithParams, JSON.stringify(obj), {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });
}

// aidemo
export function textToImage(params) {
  const obj = { ...params };
  const urlWithParams = `${endpoints.textToImage}`;
  return apiClient.post(urlWithParams, JSON.stringify(obj), {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });
}

export const textToImageStatus = (params, headers) =>
  apiClient.get(endpoints.textToImageStatus, {
    params,
    headers,
    withCredentials: true,
  });

export function imgUpload(params) {
  const urlWithParams = `${endpoints.imgUpload}`;
  return apiClient.post(urlWithParams, params, {
    headers: {
      "Content-Type": "multipart/form-data", // 不需要显式设置这个，浏览器会自动处理
    },
    withCredentials: true,
  });
}

export function imgToVideo(params) {
  const obj = { ...params };
  const urlWithParams = `${endpoints.imgToVideo}`;
  return apiClient.post(urlWithParams, JSON.stringify(obj), {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });
}

export const imgToVideoStatus = (params, headers) =>
  apiClient.get(endpoints.imgToVideoStatus, {
    params,
    headers,
    withCredentials: true,
  });

export function getChatGpt(params) {
  const obj = { ...params };
  const urlWithParams = `${endpoints.chatgpt}`;
  return apiClient.post(urlWithParams, JSON.stringify(obj), {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });
}
